export const GACategories = {
    AUTHENTICATION: 'authentication',
    DISCLAIMERS: 'disclaimers',
    DOCUMENTS: 'documents',
    ORDERS: 'orders',
    PRODUCTS: 'products',
    REPORTING: 'reporting',
    SEEDS: 'seeds',
    TAGLINES: 'taglines',
};
export const GAActionKeys = {
    AGRONOMY_REFERENCE_SHEET_CREATE: 'agronomy_reference_sheet_create',
    AGRONOMY_REFERENCE_SHEET_EDIT: 'agronomy_reference_sheet_edit',
    AGRONOMY_REFERENCE_SHEET_PUBLISH: 'agronomy_reference_sheet_publish',
    AGRONOMY_REFERENCE_SHEET_UNPUBLISH: 'agronomy_reference_sheet_unpublish',
    BRANDING_CREATE: 'branding_create',
    BRANDING_DELETE: 'branding_delete',
    BRANDING_EDIT: 'branding_edit',
    CATALOG_CREATE_FULLSCREEN_IMAGE: 'catalog_create_fullscreen_image',
    CATALOG_UPDATE_FULLSCREEN_IMAGE: 'catalog_update_fullscreen_image',
    CATALOG_CREATE_FULLSCREEN_IMAGE_PUBLISH: 'catalog_create_fullscreen_image_publish',
    CATALOG_CREATE_FULLSCREEN_IMAGE_UNPUBLISH: 'catalog_create_fullscreen_image_unpublish',
    COVER_CREATE: 'cover_create',
    COVER_DELETE: 'cover_delete',
    COVER_IMAGE_SMALL_CREATE: 'cover_image_small_create',
    COVER_IMAGE_SMALL_DELETE: 'cover_image_small_delete',
    DISCLAIMER_CREATE: 'disclaimer_create',
    DISCLAIMER_DELETE: 'disclaimer_delete',
    DISCLAIMER_EDIT: 'disclaimer_edit',
    DOWNLOADED_PDF: 'downloaded_pdf',
    DOWNLOADED_CSV: 'downloaded_csv',
    DOWNLOADED_TECH_SHEETS: 'downloaded_techSheets',
    FILLER_IMAGE_CREATE: 'filler_image_create',
    FILLER_IMAGE_EDIT: 'filler_image_edit',
    FILLER_IMAGE_DELETE: 'filler_image_delete',
    LOGIN: 'login',
    LOGO_ARCHIVE: 'logo_archive',
    LOGO_COMPLIMENTARY_CREATE: 'logo_complimentary_create',
    LOGO_COMPLIMENTARY_DELETE: 'logo_complimentary_delete',
    LOGO_COMPLIMENTARY_EDIT: 'logo_complimentary_edit',
    LOGO_CREATE: 'logo_create',
    LOGO_EDIT: 'logo_edit',
    ORDER: 'order',
    ORDER_DELETE: 'order_delete',
    ORDER_STATUS_CHANGE: 'order_status_change',
    PRODUCT_CREATE: 'product_create',
    PRODUCT_DELETE: 'product_delete',
    PRODUCT_EDIT: 'product_edit',
    PRODUCT_PUBLISH: 'product_publish',
    PRODUCT_UNPUBLISH: 'product_unpublish',
    SEED_CLONE: 'seed_clone',
    SEED_CREATE: 'seed_create',
    SEED_EDIT: 'seed_edit',
    SEED_ICON_CREATE: 'seed_icon_create',
    SEED_ICON_EDIT: 'seed_icon_edit',
    SEED_ICON_DELETE: 'seed_icon_delete',
    SEED_ICON_PUBLISH: 'seed_icon_publish',
    SEED_ICON_UNPUBLISH: 'seed_icon_unpublish',
    SEED_PUBLISH: 'seed_publish',
    SEED_UNPUBLISH: 'seed_unpublish',
    SEED_TECH_SHEET_CREATE: 'seed_tech_sheet_create',
    SEED_TECH_SHEET_PUBLISH: 'seed_tech_sheet_publish',
    SEED_TECH_SHEET_UNPUBLISH: 'seed_tech_sheet_unpublish',
    TAGLINE_CREATE: 'tagline_create',
    TAGLINE_DELETE: 'tagline_delete',
    TAGLINE_EDIT: 'tagline_edit',
};



// WEBPACK FOOTER //
// ./src/infrastructure/GoogleAnalyticsKeys.ts